import { IndexedDBCache } from 'finhelper';

export default class CacheHelper {
  //добавляем цифры в префиксы, если изменилась логика, тогда у клиента данные обновлятся

  // Префиксы
  static BALANCE_PREFIX = 'balance_';
  static BALANCE_ACCOUNTS_PREFIX = 'balance_accounts_';
  static BALANCE_INVESTS_PREFIX = 'balance_invests_';
  static BALANCE_PROPERTIES_PREFIX = 'balance_properties_';
  static BALANCE_OBLIGATIONS_PREFIX = 'balance_obligations_';

  static TACTICS_MONTH_PREFIX = 'tactics_by_month_';
  static DIVIDENDS_PREFIX = 'dividends_by_instruments_';
  static COURSES_PREFIX = 'courses_';

  // Статические ключи
  static SERVER_DATA = 'server';
  static CURRENCIES = 'currencies';

  static BALANCE = `${CacheHelper.BALANCE_PREFIX}{clientId}.{currencyId}`;

  // Новые ключи для разделенного кеша
  static BALANCE_ACCOUNTS = `${CacheHelper.BALANCE_ACCOUNTS_PREFIX}{clientId}.{currencyId}`;
  static BALANCE_INVESTS = `${CacheHelper.BALANCE_INVESTS_PREFIX}{clientId}.{currencyId}`;
  static BALANCE_PROPERTIES = `${CacheHelper.BALANCE_PROPERTIES_PREFIX}{clientId}.{currencyId}`;
  static BALANCE_OBLIGATIONS = `${CacheHelper.BALANCE_OBLIGATIONS_PREFIX}{clientId}.{currencyId}`;

  static DIVIDENDS = `${CacheHelper.DIVIDENDS_PREFIX}{date}`;
  static TACTICS_MONTH = `${CacheHelper.TACTICS_MONTH_PREFIX}{clientId}.{startDate}.{endDate}.{currencyId}`;
  static COURSES = `${CacheHelper.COURSES_PREFIX}{date}`;
  static CALENDAR_PAYMENTS_DATE = `calendar_current_date`;
  static CALENDAR_PAYMENTS_TYPE = `calendar_view_type`;

  /**
   * Генерирует ключ на основе шаблона и параметров.
   *
   * @param pattern - шаблон ключа, например, 'balance_{clientId}.{currencyId}'
   * @param params - объект с подстановками, например, { clientId: 123, currencyId: 456 }
   * @return {*}
   */
  static generateKey = (pattern, params) => {
    Object.keys(params).forEach((key) => {
      // Заменяем все вхождения {key} в шаблоне на значение из params
      pattern = pattern.replace(new RegExp(`{${key}}`, 'g'), params[key]);
    });

    return pattern;
  };

  /**
   * Удаляет конкретную часть balance кеша
   * @param {string} cacheType - тип кеша ('accounts', 'invests', 'properties', 'obligations', 'all')
   * @param {object} params - параметры для генерации ключа
   */
  static async clearBalanceCachePart(cacheType, params) {
    const cacheKeys = {
      accounts: CacheHelper.BALANCE_ACCOUNTS,
      invests: CacheHelper.BALANCE_INVESTS,
      properties: CacheHelper.BALANCE_PROPERTIES,
      obligations: CacheHelper.BALANCE_OBLIGATIONS,
    };

    if (cacheType === 'all') {
      // Удаляем все части + старый общий кеш
      await Promise.all([
        IndexedDBCache.delete(CacheHelper.generateKey(CacheHelper.BALANCE_ACCOUNTS, params)),
        IndexedDBCache.delete(CacheHelper.generateKey(CacheHelper.BALANCE_INVESTS, params)),
        IndexedDBCache.delete(CacheHelper.generateKey(CacheHelper.BALANCE_PROPERTIES, params)),
        IndexedDBCache.delete(CacheHelper.generateKey(CacheHelper.BALANCE_OBLIGATIONS, params)),
        IndexedDBCache.delete(CacheHelper.generateKey(CacheHelper.BALANCE, params)),
      ]);
    } else if (cacheKeys[cacheType]) {
      await IndexedDBCache.delete(CacheHelper.generateKey(cacheKeys[cacheType], params));
    }
  }

  /**
   * Очищает весь IndexedDB кэш.
   */
  static startAgain() {
    IndexedDBCache.clearAll();
  }

  /**
   * Очищает localStorage и IndexedDB кэш.
   */
  static clearAll() {
    localStorage.clear();
    IndexedDBCache.clearAll();
  }
}
